module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a8debf706094634d9d5f49690da9cf44.png";